import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import {
  NavWrapper,
  ListElement,
  IndexIndicator,
  HoverableLink,
  HoverableSpan,
  HoverableAnchor,
  SubMenu,
  MenuList,
} from "./style"
import { useMousePosition } from "shared/Hooks/useMousePosition"

export const Navigation = ({ active, setCanToggle }) => {
  const routes = [
    {
      name: "Sklep",
      id: "01",
      path: "https://sklep.beksinski.com.pl/",
      external: true,
    },
    {
      name: "Wirtualny spacer",
      id: "02",
      path:
        "https://sklep.beksinski.com.pl/index.php/kategoria-produktu/wirtualny-spacer/",
      external: true,
    },
    {
      name: "Bilety",
      id: "03",
      path: "https://koncerty-beksinski.pl/",
      external: true,
    },
    {
      name: "Wystawy",
      id: "04",
      path: "/wystawy",
    },
    {
      name: "Koncerty",
      id: "05",
      path: "/koncerty",
    },
    {
      name: "Virtual Reality",
      id: "06",
      path: "/virtual-reality",
    },
    {
      name: "Spektakle",
      id: "07",
      path: "/spektakle",
    },
    {
      name: "Dla szkół",
      id: "08",
      path: "/dla-szkol",
    },
    {
      name: "Biografia",
      id: "09",
      path: "/",
      submenu: [
        {
          name: "Biografia",
          path: "/biografia",
        },
        {
          name: "Twórczość",
          path: "/tworczosc",
        },
      ],
    },
    {
      name: "Audiobooki",
      id: "10",
      path: "/audiobooki",
    },
    {
      name: "O fundacji",
      id: "11",
      path: "/o-fundacji",
    },
    {
      name: "Kontakt",
      id: "12",
      path: "/kontakt",
    },
  ]
  const [subMenuOpen, setSubMenuOpen] = useState(false)
  const [calculatedPos, setCalculatedPos] = useState({ x: 0, y: 0 })
  const [show, setShow] = useState(false)
  const [animInProgress, setAnimInProgress] = useState(null)
  const position = useMousePosition()

  const totalAnimationTime = 0.8 //s
  const singleElementDuration = 0.4

  useEffect(() => {
    if (!animInProgress)
      setCalculatedPos({
        x: 0.04 * (window.innerWidth / 2 - position.x),
        y: 0.11 * (window.innerHeight / 2 - position.y),
      })
    if (active != show && active == false) {
      setAnimInProgress(
        setTimeout(() => {
          setShow(false)
          setAnimInProgress(null)
          setCanToggle(true)
        }, (totalAnimationTime + singleElementDuration) * 1000)
      )
      setCanToggle(false)
    } else if (active != show) {
      setShow(true)
      setAnimInProgress(
        setTimeout(() => {
          setAnimInProgress(false)
          setCanToggle(true)
        }, (totalAnimationTime + singleElementDuration) * 1000)
      )
      setCanToggle(false)
    }
  }, [position, active, show])

  return (
    show && (
      <NavWrapper
        active={active}
        duration={totalAnimationTime + singleElementDuration}
      >
        <nav>
          <MenuList
            style={{
              transform: `translate(${calculatedPos.x}px,${calculatedPos.y}px)`,
            }}
          >
            {routes.map((route, index) => (
              <ListElement
                delay={
                  totalAnimationTime *
                  (active ? index / routes.length : 1 - index / routes.length)
                }
                show={active}
                duration={singleElementDuration}
                key={route.id}
                onClick={e => {
                  if (route.submenu) {
                    setSubMenuOpen(!subMenuOpen)
                    e.preventDefault()
                  }
                }}
              >
                {route.submenu ? (
                  <>
                    <HoverableSpan activeClassName="active">
                      {route.name}
                    </HoverableSpan>

                    <IndexIndicator>{route.id}</IndexIndicator>
                    {route.submenu && (
                      <SubMenu open={subMenuOpen}>
                        {route.submenu.map(subRoute => (
                          <Link key={subRoute.path} to={subRoute.path}>
                            {subRoute.name}
                          </Link>
                        ))}
                      </SubMenu>
                    )}
                  </>
                ) : route.external ? (
                  <>
                  <HoverableAnchor href={route.path} target="_blank">
                    {route.name}
                  </HoverableAnchor>
                  <IndexIndicator>{route.id}</IndexIndicator>
                </>
                ) : (
                  <>
                    <HoverableLink to={route.path} activeClassName="active">
                      {route.name}
                    </HoverableLink>
                    <IndexIndicator>{route.id}</IndexIndicator>
                  </>
                )}
              </ListElement>
            ))}
          </MenuList>
        </nav>
      </NavWrapper>
    )
  )
}
